export enum EventType {
    VideoMotionDetection = 10110,
    VideoLoiteringDetection = 10210,
    VideoRailDefenderDetection = 10310,
    VideoViolentBehaviorDetection = 10410,
    VideoUnattendedObjectDetection = 10510,
    VideoFallDetection = 10610,
    VideoFireDetection = 11010,
    InputModuleBinaryTriggerAlarm = 19010,
    PhysicalObjectConnectionFailure = 20110,
    PhysicalObjectConnectionReset = 20120,
    PowerFailure = 20210,
    PowerReset = 20220,
    IssueAlarm = 31100,
    SiteTestAlarmSending = 80110,
    SiteTestFullAlarmFlow = 80120,
    UnknownSourceEventMissing = 100010,
}
